export default __webpack_public_path__ + "static/topCards@2x-2af32dd08b340935fa119c0b2754b568.png";